import { useEffect, useState } from "react";

const useOnlineStatus = () => {
	const [isOnline, setIsOnline] = useState(() => navigator.onLine);
	useEffect(() => {
		const update = () => setIsOnline(navigator.onLine);
		window.addEventListener("online", update);
		window.addEventListener("offline", update);
		return () => {
			window.removeEventListener("online", update);
			window.removeEventListener("offline", update);
		};
	}, []);
	return isOnline;
};

export default useOnlineStatus;
